<template>
  <div class="container">
    <div class="login-content">
      <div class="login-body">
        <div class="title">漳州美术馆数据后台</div>
        <div class="box">
          <input class="input" :class="nameErr != '' ? 'input-err' : ''" type="text" v-model="name" placeholder="账号" />
          <div class="err">{{ nameErr }}</div>
          <input class="input" :class="passwordErr != '' ? 'input-err' : ''" type="password" v-model="password"
            placeholder="密码" />
          <div class="err">{{ passwordErr }}</div>
          <div class="remember">
            <input type="checkbox" id="remember" v-model="isRemember" />
            <label for="remember">自动登录</label>
          </div>
          <div class="btn" @click="login">登录</div>
          <div class="err">{{ loginErr }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import md5 from 'js-md5'
import https from '../https.js'
export default {
  name: 'login',
  components: {
  },
  data() {
    return {
      name: "",
      nameErr: "",
      password: "",
      passwordErr: "",
      loginErr: "",
      isRemember: false,
      isSub: false,
    }
  },
  mounted() {
    let name = sessionStorage.getItem(md5("yslt_account"))
    let password = sessionStorage.getItem(md5("yslt_password"))
    if (name && password) {
      this.loginPost(name, password)
    } else {
      name = localStorage.getItem(md5("yslt_account"))
      password = localStorage.getItem(md5("yslt_password"))
      if (name) {
        this.name = name
      }
      if (name && password) {
        this.loginPost(name, password)
      }
    }
  },
  methods: {
    login() {
      if (this.isSub) {
        return
      }
      this.isSub = true
      this.nameErr = ''
      this.passwordErr = ''
      this.loginErr = ''
      if (this.name == '') {
        this.nameErr = '账号不能为空'
        return
      } else if (this.password == '') {
        this.passwordErr = '密码不能为空'
        return
      }
      this.loginPost(this.name, md5(this.password))
    },
    loginPost(name, password) {
      let params = {
        'account': name,
        'password': password
      }
      https.fetchPost('/api/v1/appGallery/login', params).then((data) => {
        if (data.code == 0) {
          if (this.isRemember) {
            localStorage.setItem(md5("yslt_account"), name)
            localStorage.setItem(md5("yslt_password"), password)
          }
          sessionStorage.setItem(md5("yslt_account"), name)
          sessionStorage.setItem(md5("yslt_password"), password)
          this.GLOBAL.name = name
          this.GLOBAL.password = password
          this.GLOBAL.id = data.galleryId
          this.$router.push('/UserData')
        } else {
          this.loginErr = data.message
        }
        this.isSub = false
      }).catch(err => {
        console.log(err)
        this.isSub = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  max-height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: cornflowerblue;
}

.login-content {
  >img {
    height: 80px;
    width: auto;
    margin-bottom: 16px;
  }

  .login-body {
    background-color: #fff;
    padding: 50px 40px;
    border-radius: 8px;
    width: 400px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
      color: #000;
      font-weight: 600;
      text-align: center;
      margin-bottom: 30px;
    }

    .box {
      box-sizing: border-box;

      .input {
        width: 100%;
        border: 1px solid #DCDFE6;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 16px;
      }

      .input:focus {
        outline: none;
        border-color: #20a53a;
      }

      .input-err {
        outline: none;
        border-color: #ef0808;
      }

      .input-err:focus {
        outline: none;
        border-color: #ef0808;
      }

      .err {
        color: #ef0808;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        height: 14px;
        text-align: left;
        margin-bottom: 6px;
      }

      .remember {
        display: flex;

        >input {
          height: 16px;
          width: 16px;
        }
      }

      .btn {
        margin-top: 20px;
        width: 100%;
        padding: 12px 0;
        text-align: center;
        color: #fff;
        background-color: royalblue;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue